import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteAppointmentType(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteAppointmentType = (appointmentTypeId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`appointment-types/${appointmentTypeId}/`);
  };

  return useMutation(deleteAppointmentType, {
    onSuccess: () => {
      queryClient.removeQueries(['appointmentType']);
      queryClient.invalidateQueries({ queryKey: ['appointmentPayRateLookups'] });
      queryClient.invalidateQueries({ queryKey: ['packages'] });
      queryClient.invalidateQueries({ queryKey: ['attendanceRules'] });
      queryClient.invalidateQueries({ queryKey: ['creditDispensations'] });
    },
  });
}
